import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import home_bann1 from "../../assets/images/banner/GenieBluComputerGlassesWebsiteBanner.png";
import home_bann1_mob from "../../assets/images/banner/computeGlassesMobile.png"; // Mobile banner

// Reusable Image Component
const Image = ({ imgSrc, style }) => {
  return <img src={imgSrc} alt="Banner" style={style} />;
};

const Banner9 = () => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate(); // Hook for navigation

  useEffect(() => {
    // Function to check screen size
    const checkScreenSize = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize); // Listen for resize

    return () => window.removeEventListener("resize", checkScreenSize); // Cleanup
  }, []);

  const imageStyle = {
    width: "100%",
    height: "auto",
    objectFit: "contain",
    display: "block",
    cursor: "pointer", // Add cursor pointer for better UX
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "auto",
    overflow: "hidden",
  };

  // Function to handle click and navigate
  const handleBannerClick = () => {
    const message = "Genie Blu";
    const key = 'ca_id';
    const value = 12;
    const table = 'getallproduct';
    // Pass the message to ShowMoreComponent via state
    navigate('/prodList', { state: { message, key,value,table} });
  };

  return (
    <div>
      {/* Banner Section */}
      <div style={containerStyle} onClick={handleBannerClick}>
        {/* Dynamically change image based on screen size */}
        <Image imgSrc={isMobile ? home_bann1_mob : home_bann1} style={imageStyle} />
      </div>

      {/* Divider Section */}
      {/* <div className="px-4">
        <div className="flex items-center justify-center my-6">
          <div className="w-full border-t border-gray-300"></div>
          <span className="mx-4 text-black text-sm md:text-base font-semibold whitespace-nowrap">
            GENIE BLUE COMPUTER GLASSES 
          </span>
          <div className="w-full border-t border-gray-300"></div>
        </div>
      </div> */}
    </div>
  );
};

export default Banner9;
